
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Components
 |--------------------------------------------------------------------------
 |
 | Here we will load the Spark components which makes up the core client
 | application. This is also a convenient spot for you to load all of
 | your components that you write while building your applications.
 */

require('./../spark-components/bootstrap');

require('./home');

// Passport

Vue.component(
    'passport-clients',
    require('./passport/Clients.vue')
);

Vue.component(
    'passport-authorized-clients',
    require('./passport/AuthorizedClients.vue')
);

Vue.component(
    'passport-personal-access-tokens',
    require('./passport/PersonalAccessTokens.vue')
);

// Global Helper Components

Vue.component(
    'alert',
    require('./globals/Alert.vue')
);

// Developer Tool Components

Vue.component(
    'developer-tools',
    require('./developer/DeveloperTools.vue')
);

// Imports

Vue.component(
    'import-status',
    require('./imports/ImportStatus.vue')
);

Vue.component(
    'import-log',
    require('./imports/ImportLog.vue')
);

// Clients

Vue.component(
    'client-view',
    require('./clients/ClientView.vue')
);

// Exports

Vue.component(
    'export-list',
    require('./exports/ExportList.vue')
);

// Dashbaord

// Vue.component(
//     'client-picker',
//     require('./dashboard/ClientPicker.vue')
// );

Vue.component(
    'client-pacing',
    require('./dashboard/pacing/ClientPacing.vue')
);

// User Settings

Vue.component(
    'user-clients',
    require('./user/UserClients.vue')
);



// WEBPACK FOOTER //
// ./resources/assets/js/components/bootstrap.js